import { render } from "./KpiDocumentDesignerSaveDialog.vue?vue&type=template&id=6a2857ca&ts=true"
import script from "./KpiDocumentDesignerSaveDialog.vue?vue&type=script&lang=ts"
export * from "./KpiDocumentDesignerSaveDialog.vue?vue&type=script&lang=ts"

import "./KpiDocumentDesignerSaveDialog.vue?vue&type=style&index=0&id=6a2857ca&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__